import { all, call, put, takeEvery, takeLatest } from 'redux-saga/effects';

import * as actions from '@actions/gameChanger';
import {
  amazonCentralPull,
  amazonSellerCentralRequest,
  createAmazonTransactionsToXlsFilesFormat,
  deleteGameChangerOutputFileRequest,
  downloadGameChangerFileRequest,
  getListGameChangerOutputFiles,
  listGameChangerOutputRequest,
  postGamechangerOutputFiles,
  readGameChangerOutputFile,
} from '@api/gameChanger';
import {
  DELETE_GAME_CHANGER_OUTPUT_FILE_REQUEST,
  DELETE_OUTPUT_FILE_REQUEST,
  DOWNLOAD_GAME_CHANGER_FILE,
  DOWNLOAD_GAME_CHANGER_OUTPUT_FILE,
  GAME_CHANGER_OUTPUT_FILE_IDS_REQUEST,
  GET_AMAZON_CENTRAL_TRANSACTIONS_REQUEST,
  GET_AMAZON_SELLER_CENTRAL_REQUEST,
  GET_GAME_CHANGER_OUTPUT_REQUEST,
  GET_LIST_GAME_CHANGER_OUTPUT_FILES_REQUEST,
  POST_GAME_CHANGER_OUTPUT_FILES_REQUEST,
  RUN_GAME_CHANGER_REQUEST,
} from '@constants/action-types/gameChanger';
import { ADD_DATA } from '@constants/general';
import { history, vfileRoutes } from '@routes';
import { fetchGameChangerOutputFileIdsSaga } from '@sagas/gameChanger/fetchGameChangerOutputFileIdsSaga';
import { handleRequest } from '@sagas/request';

import { deleteOutputFilesSaga } from './deleteOutputFilesSaga';

export const handleGetListGameChangerOutputFiles = function* ({ payload }) {
  try {
    const response = yield call(getListGameChangerOutputFiles, payload);
    if (response.isAxiosError)
      return yield put(actions.getListGameChangerOutputFilesFailure(response.message));
    yield put(actions.getListGameChangerOutputFilesSuccess(response));
  } catch (e) {
    yield put(actions.getListGameChangerOutputFilesFailure(e));
  }
};

export const handleGetAmazonCentralTransactions = function* ({ payload }) {
  try {
    const response = yield call(amazonCentralPull, payload);
    if (response && (response.status === 404 || response.status === 400))
      return yield put(actions.getAmazonCentralTransactionsFailure(response));
    if (response.isAxiosError)
      return yield put(actions.getAmazonCentralTransactionsFailure(response));
    yield put(actions.getAmazonCentralTransactionsSuccess(response));
  } catch (e) {
    yield put(actions.getAmazonCentralTransactionsFailure(e));
  }
};

export const handleAmazonSellerCentralRequest = function* ({ payload }) {
  try {
    const response = yield call(amazonSellerCentralRequest, payload);
    if (response.isAxiosError)
      return yield put(actions.getAmazonSellerCentralFailure(response.message));
    yield put(actions.getAmazonSellerCentralSuccess(response));
  } catch (e) {
    yield put(actions.getAmazonSellerCentralFailure(e));
  }
};

export const handleDownloadGameChangerFile = function* ({ payload }) {
  try {
    const response = yield call(downloadGameChangerFileRequest, payload);
    response.url &&
      setTimeout(() => {
        window.open(response.url);
      }, 250);
  } catch (e) {
    // do nothing
  }
};

export const handleDownloadGameChangerOutputFile = function* ({ payload }) {
  try {
    const response = yield call(readGameChangerOutputFile, payload);
    response.url &&
      setTimeout(() => {
        window.open(response.url);
      }, 250);
  } catch (e) {
    // do nothing
  }
};

export const handleRunGameChanger = function* ({ payload }) {
  try {
    const response = yield call(createAmazonTransactionsToXlsFilesFormat, payload);
    if (response.isAxiosError) return yield put(actions.runGameChangerFailure(response.message));
    yield put(actions.runGameChangerSuccess(response));
    if (payload.onSuccess) {
      yield call(payload.onSuccess);
    }
  } catch (e) {
    yield put(actions.runGameChangerFailure(e));
  }
};

export const handleGameChangerOutputRequest = function* ({ payload }) {
  try {
    const response = yield call(listGameChangerOutputRequest, payload);
    if (response.isAxiosError)
      return yield put(actions.runGameChangerOutputFailure(response.message));
    yield put(actions.runGameChangerOutputSuccess(response));
  } catch (e) {
    yield put(actions.runGameChangerOutputFailure(e));
  }
};

export const handleDeleteGameChangerOutputFile = function* ({ payload }) {
  try {
    const response = yield call(deleteGameChangerOutputFileRequest, payload);
    if (response.isAxiosError)
      return yield put(actions.deleteGameChangerOutputFileFailure(response.message));
    yield put(actions.deleteGameChangerOutputFileSuccess(response));
  } catch (e) {
    yield put(actions.deleteGameChangerOutputFileFailure(e));
  }
};

export const handlePostGameChangerOutputFiles = function* ({ payload }) {
  try {
    const { filingId, mode } = payload;
    const response = yield call(postGamechangerOutputFiles, payload);
    if (response.isAxiosError) return yield put(actions.postGameChangerOuputFilesFailure(response));
    yield put(actions.postGameChangerOuputFilesSuccess(response));
    yield call(
      history.push,
      vfileRoutes.FILING_UPLOAD.make(filingId, mode === ADD_DATA ? 'add' : undefined)
    );
  } catch (e) {
    yield put(actions.postGameChangerOuputFilesFailure(e));
  }
};

export default all([
  takeEvery(GET_LIST_GAME_CHANGER_OUTPUT_FILES_REQUEST, handleGetListGameChangerOutputFiles),
  takeEvery(GET_AMAZON_CENTRAL_TRANSACTIONS_REQUEST, handleGetAmazonCentralTransactions),
  takeEvery(DOWNLOAD_GAME_CHANGER_FILE, handleDownloadGameChangerFile),
  takeEvery(GET_AMAZON_SELLER_CENTRAL_REQUEST, handleAmazonSellerCentralRequest),
  takeEvery(RUN_GAME_CHANGER_REQUEST, handleRunGameChanger),
  takeEvery(GET_GAME_CHANGER_OUTPUT_REQUEST, handleGameChangerOutputRequest),
  takeEvery(DOWNLOAD_GAME_CHANGER_OUTPUT_FILE, handleDownloadGameChangerOutputFile),
  takeEvery(DELETE_GAME_CHANGER_OUTPUT_FILE_REQUEST, handleDeleteGameChangerOutputFile),
  takeEvery(POST_GAME_CHANGER_OUTPUT_FILES_REQUEST, handlePostGameChangerOutputFiles),
  takeEvery(GAME_CHANGER_OUTPUT_FILE_IDS_REQUEST, fetchGameChangerOutputFileIdsSaga),
  takeEvery(DELETE_OUTPUT_FILE_REQUEST, deleteOutputFilesSaga),
  takeLatest(actions.getListGameChangerFilesRequest.type, handleRequest),
  takeEvery(actions.gameChangerImportDataRequest.type, handleRequest),
]);
